!function() {
  "use strict";

  /* ========================================
     admyre-hotspots — Hero image with hotspots
     ======================================== */

  if (!customElements.get("admyre-hotspots")) {
    customElements.define("admyre-hotspots", class extends HTMLElement {
      constructor() {
        super();
        this.hotspots = [];
        this.mobileCards = [];
        this.mobileSlider = null;
        this.activeHotspot = null;
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.handleOtherPopup = this.handleOtherPopup.bind(this);
        this.isMobile = function() { return window.innerWidth < 750; };
      }

      connectedCallback() {
        this.hotspots = this.querySelectorAll("[data-hotspot]");
        this.mobileSlider = this.querySelector("[data-mobile-slider]");
        this.mobileCards = this.querySelectorAll("[data-mobile-card]");

        if (!this.hotspots.length) return;

        this.positionPopups();
        this.bindEvents();
      }

      disconnectedCallback() {
        document.removeEventListener("click", this.handleOutsideClick);
        document.removeEventListener("admyre:popup-open", this.handleOtherPopup);
      }

      getMobileHotspotAction() {
        var raw = this.getAttribute("data-mobile-hotspot-action");
        if (raw == null || typeof raw !== "string") return "popup";
        var a = raw.trim().toLowerCase();
        if (a === "product" || a === "carousel") return a;
        return "popup";
      }

      bindEvents() {
        var self = this;
        document.addEventListener("click", this.handleOutsideClick);
        document.addEventListener("admyre:popup-open", this.handleOtherPopup);

        this.hotspots.forEach(function(hotspot, index) {
          var dot = hotspot.querySelector(".admyre-hotspot__dot");
          if (!dot) return;

          dot.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();

            if (self.isMobile()) {
              var mobileAction = self.getMobileHotspotAction();
              if (mobileAction === "popup") {
                if (hotspot.classList.contains("is-active")) {
                  self.hidePopup(hotspot);
                } else {
                  self.hideAllPopups();
                  self.showPopup(hotspot);
                }
                return;
              }
              if (mobileAction === "product") {
                var productUrl = hotspot.dataset.productUrl;
                if (productUrl) window.location.assign(productUrl);
                return;
              }
              self.scrollToMobileCard(index);
              return;
            }

            if (hotspot.classList.contains("is-active")) {
              self.hidePopup(hotspot);
            } else {
              self.hideAllPopups();
              self.showPopup(hotspot);
            }
          });

          if (window.matchMedia("(hover: hover)").matches) {
            hotspot.addEventListener("mouseenter", function() {
              if (!self.isMobile()) self.showPopup(hotspot);
            });
            hotspot.addEventListener("mouseleave", function() {
              if (!self.isMobile()) self.hidePopup(hotspot);
            });
          }
        });
      }

      showPopup(hotspot) {
        if (this.activeHotspot && this.activeHotspot !== hotspot) {
          this.hidePopup(this.activeHotspot);
        }
        hotspot.classList.add("is-active");
        this.activeHotspot = hotspot;
        document.dispatchEvent(new CustomEvent("admyre:popup-open", { detail: { source: this } }));
      }

      hidePopup(hotspot) {
        hotspot.classList.remove("is-active");
        if (this.activeHotspot === hotspot) this.activeHotspot = null;
      }

      hideAllPopups() {
        this.hotspots.forEach(function(h) { h.classList.remove("is-active"); });
        this.activeHotspot = null;
      }

      handleOutsideClick(e) {
        if (!e.target.closest("[data-hotspot]")) this.hideAllPopups();
      }

      handleOtherPopup(e) {
        if (e.detail && e.detail.source !== this) this.hideAllPopups();
      }

      scrollToMobileCard(index) {
        if (!this.mobileSlider || !this.mobileCards.length) return;

        var card = this.mobileCards[index];
        if (!card) return;

        var sliderLeft = parseInt(window.getComputedStyle(this.mobileSlider).paddingLeft) || 0;
        this.mobileSlider.scrollTo({
          left: card.offsetLeft - sliderLeft,
          behavior: "smooth"
        });

        this.mobileCards.forEach(function(c) { c.classList.remove("is-highlighted"); });
        card.classList.add("is-highlighted");
        setTimeout(function() { card.classList.remove("is-highlighted"); }, 1500);
      }

      positionPopups() {
        this.hotspots.forEach(function(hotspot) {
          var popup = hotspot.querySelector(".admyre-hotspot__popup");
          if (!popup) return;

          var x = parseFloat(hotspot.dataset.hotspotX) || 50;
          var y = parseFloat(hotspot.dataset.hotspotY) || 50;

          if (x > 55) popup.classList.add("admyre-hotspot__popup--left");
          if (y > 60) popup.classList.add("admyre-hotspot__popup--above");
        });
      }
    });
  }

  /* ========================================
     admyre-gallery-item — Per-image hotspots in gallery
     ======================================== */

  if (!customElements.get("admyre-gallery-item")) {
    customElements.define("admyre-gallery-item", class extends HTMLElement {
      constructor() {
        super();
        this.hotspots = [];
        this.activeHotspot = null;
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.handleOtherPopup = this.handleOtherPopup.bind(this);
      }

      connectedCallback() {
        this.hotspots = this.querySelectorAll("[data-hotspot]");
        if (!this.hotspots.length) return;

        this.positionPopups();
        this.bindEvents();
      }

      disconnectedCallback() {
        document.removeEventListener("click", this.handleOutsideClick);
        document.removeEventListener("admyre:popup-open", this.handleOtherPopup);
      }

      bindEvents() {
        var self = this;
        document.addEventListener("click", this.handleOutsideClick);
        document.addEventListener("admyre:popup-open", this.handleOtherPopup);

        this.hotspots.forEach(function(hotspot) {
          var dot = hotspot.querySelector(".admyre-hotspot__dot");
          if (!dot) return;

          dot.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();

            if (hotspot.classList.contains("is-active")) {
              self.hidePopup(hotspot);
            } else {
              self.hideAllPopups();
              self.showPopup(hotspot);
            }
          });

          if (window.matchMedia("(hover: hover)").matches) {
            hotspot.addEventListener("mouseenter", function() {
              self.showPopup(hotspot);
            });
            hotspot.addEventListener("mouseleave", function() {
              self.hidePopup(hotspot);
            });
          }
        });
      }

      showPopup(hotspot) {
        if (this.activeHotspot && this.activeHotspot !== hotspot) {
          this.hidePopup(this.activeHotspot);
        }
        hotspot.classList.add("is-active");
        this.activeHotspot = hotspot;
        document.dispatchEvent(new CustomEvent("admyre:popup-open", { detail: { source: this } }));
      }

      hidePopup(hotspot) {
        hotspot.classList.remove("is-active");
        if (this.activeHotspot === hotspot) this.activeHotspot = null;
      }

      hideAllPopups() {
        this.hotspots.forEach(function(h) { h.classList.remove("is-active"); });
        this.activeHotspot = null;
      }

      handleOutsideClick(e) {
        if (!e.target.closest("[data-hotspot]")) this.hideAllPopups();
      }

      handleOtherPopup(e) {
        if (e.detail && e.detail.source !== this) this.hideAllPopups();
      }

      positionPopups() {
        this.hotspots.forEach(function(hotspot) {
          var popup = hotspot.querySelector(".admyre-hotspot__popup");
          if (!popup) return;

          var x = parseFloat(hotspot.dataset.hotspotX) || 50;
          var y = parseFloat(hotspot.dataset.hotspotY) || 50;

          if (x > 55) popup.classList.add("admyre-hotspot__popup--left");
          if (y > 60) popup.classList.add("admyre-hotspot__popup--above");
        });
      }
    });
  }
}();
